import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const SuccessCircle = ({ iconSize, fillColor, fillColorSecondary }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      width={size}
      height={size}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path
        d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336z"
        fill={fillColor ?? 'currentColor'}
      />
      <path
        d="M15.707 9.293a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z"
        fill={fillColorSecondary ?? 'white'}
      />
    </svg>
  )
}

export default SuccessCircle
